// extracted by mini-css-extract-plugin
export default {"nameTextClamp":"ListItem_nameTextClamp__T4qZF","locationTextClamp":"ListItem_locationTextClamp__6l-Sj","trip":"ListItem_trip__dFVYz"};